export const ButtonSpinner: React.FC = () => <div className="ButtonSpinner"></div>